import React from 'react';
import { TopToolbar, ExportButton, CreateButton, FilterButton, usePermissions, useListContext } from 'react-admin';
import AssociazioneMassivaButton from './Buttons/AssociazioneMassivaButton';
import BarcodeScannerActionButton from './Buttons/BarcodeScannerAction';
import SendToSap from './Buttons/SendToSap';
import UploadFile from './Buttons/UploadFile';
import UploadFileMassiveReject from './Buttons/UploadFileMassiveReject';
import UploadFileMultipleFilter from './Buttons/UploadFileMultipleFilter';

const PostActions = () => {
    const { total, isLoading, bulkActions,
        basePath,
        currentSort,
        exporter,
        filterValues,
        onUnselectItems,
        selectedIds,
        resource, } = useListContext();
    const { permissions } = usePermissions();
    return (
    <TopToolbar>
        {(permissions === 'approvatore') && <UploadFile />}
        {(permissions === 'approvatore') && <UploadFileMassiveReject />}
        <UploadFileMultipleFilter />
        {(permissions === 'magazziniere' || permissions === 'tecnico') && <AssociazioneMassivaButton />}
        {(permissions === 'approvatore' && localStorage.getItem('sap_off') !== 'true') && <SendToSap />}
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {(permissions === 'magazziniere' || permissions === 'tecnico') && <BarcodeScannerActionButton />}
        <FilterButton disableSaveQuery/>
        {(permissions === 'magazziniere' || permissions === 'tecnico') && <CreateButton />}
        <ExportButton
            disabled={isLoading || total === 0}
            resource={resource}
            sort={currentSort}
            filter={filterValues}
            exporter={exporter}
            maxResults={30000}
        />
    </TopToolbar>
)};

export default PostActions;